import { $t } from '../../../hooks/useTranslation';
import { renderEditCell, renderParametersCell, renderRuleCell, renderStatusCell } from './RenderCells';
export const statusColumn = {
    field: 'status',
    headerName: $t('Status'),
    flex: 1,
    renderCell: renderStatusCell
};
export const ruleColumn = {
    field: 'rule',
    headerName: $t('Rule'),
    flex: 4,
    renderCell: renderRuleCell
};
export const buildEditColumn = (onEdit) => ({
    field: '',
    flex: 10,
    renderCell: (params) => renderEditCell(params, onEdit)
});
export const buildParametersColumn = (headerName, onEdit) => ({
    field: 'parameters',
    headerName,
    flex: 10,
    renderCell: (params) => renderParametersCell(params, onEdit)
});
